import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
export function AngelikaSturnProfilPage() {
  return <div className="min-h-screen bg-white" data-id="element-813">
      <Header data-id="element-814" />
      <main className="w-full pt-[152px]" data-id="element-815">
        <div className="w-full flex justify-center" data-id="element-816">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-817">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fZrGTWuRbQfNPcwxck1wYe/Header-Profil-Angelika_Sturny.jpg" alt="Dr. Angelika Sturny" className="w-full h-full object-cover" data-id="element-818" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-819"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-820">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-821">
                <div className="max-w-lg text-left" data-id="element-822">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-823">
                    "Das größte Geschenk, das ich von jemandem empfangen kann,
                    ist, gesehen, gehört, verstanden und berührt zu werden."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-824">
                    – Virginia Satir, Psychotherapeutin
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-825">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-826">
            Profil
          </h1>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-8" data-id="element-827">
            <p data-id="element-828">
              Ich bin promovierte Diplom-Psychologin und begleite Menschen als
              Psychotherapeutin, Coach und systemische Familientherapeutin – ob
              Einzelpersonen, Paare, Familien oder Kinder und Jugendliche.
            </p>
            <p data-id="element-829">
              Mit meiner staatlichen Zulassung als Heilpraktikerin für
              Psychotherapie und über 25 Jahren Erfahrung in der
              Personalentwicklung eines DAX-Unternehmens sowie in NGOs verbinde
              ich psychologisches Fachwissen mit praxisnaher Expertise.
            </p>
          </div>
          <div className="mb-4" data-id="element-830">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-831">
              Meine Motivation
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-832">
              <p data-id="element-833">
                Die Verbindung von beruflicher Expertise, familiärer Erfahrung
                und sozialem Engagement bildet das Fundament meiner Arbeit als
                systemische Familientherapeutin. Ich weiß, wie herausfordernd
                Beziehungen sein können – und wie viel Kraft in ehrlichem
                Kontakt, gegenseitigem Verständnis und gemeinsamer Entwicklung
                liegt.
              </p>
              <p data-id="element-834">
                Meine therapeutische Haltung ist geprägt von Wertschätzung,
                Klarheit und einem tiefen Vertrauen in die Ressourcen jedes
                Menschen. Ich glaube daran, dass Veränderung möglich ist – wenn
                wir bereit sind, hinzuschauen, zu verstehen und neue Wege zu
                gehen.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg" data-id="element-835">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-836">
            Was mich ausmacht
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:gap-8" data-id="element-837">
            <div className="bg-gray-50 rounded-lg" data-id="element-838">
              <ul className="space-y-5" data-id="element-839">
                <li className="flex items-start" data-id="element-840">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-841"></div>
                  <div data-id="element-842">
                    <p className="text-gray-600" data-id="element-843">
                      Ganzheitlicher Blick auf Beziehungen, wiederkehrende
                      Muster und individuelle wie gemeinsame
                      Entwicklungsprozesse
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-844">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-845"></div>
                  <div data-id="element-846">
                    <p className="text-gray-600" data-id="element-847">
                      Langjährige Erfahrung in der Arbeit mit Menschen in
                      komplexen Lebenssituationen
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-848">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-849"></div>
                  <div data-id="element-850">
                    <p className="text-gray-600" data-id="element-851">
                      Empathie und ein geschützter Raum für persönliche Prozesse
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg" data-id="element-852">
              <ul className="space-y-5" data-id="element-853">
                <li className="flex items-start" data-id="element-854">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-855"></div>
                  <div data-id="element-856">
                    <p className="text-gray-600" data-id="element-857">
                      Seit über 20 Jahren verheiratet und Mutter eines
                      erwachsenen Sohnes
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-858">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-859"></div>
                  <div data-id="element-860">
                    <p className="text-gray-600" data-id="element-861">
                      Engagement für soziale Gerechtigkeit und Gewaltprävention
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-862">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-863"></div>
                  <div data-id="element-864">
                    <p className="text-gray-600" data-id="element-865">
                      Seit über 30 Jahren aktiv in der Fachberatungsstelle
                      Frauennotruf Heidelberg gegen sexuelle Gewalt an Frauen
                      und Mädchen – aktuell erneut als Vorstandsmitglied
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-866">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-867">
            Qualifikationen
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:gap-8" data-id="element-868">
            <div className="bg-gray-50 rounded-lg" data-id="element-869">
              <ul className="space-y-5" data-id="element-870">
                <li className="flex items-start" data-id="element-871">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-872"></div>
                  <div data-id="element-873">
                    <p className="text-gray-700 font-medium" data-id="element-874">
                      Promotion an der Universität Saarbrücken (Dr. phil.)
                    </p>
                    <p className="text-gray-600" data-id="element-875">
                      Wirtschaft- und Sozialpsychologie
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-876">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-877"></div>
                  <div data-id="element-878">
                    <p className="text-gray-700 font-medium" data-id="element-879">Studium</p>
                    <p className="text-gray-600" data-id="element-880">
                      Klinische Psychologie an der Universität Landau/Pfalz,
                      Heidelberg und an der University Brunel, Uxbridge, London
                      (UK)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-881">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-882"></div>
                  <div data-id="element-883">
                    <p className="text-gray-700 font-medium" data-id="element-884">
                      Weiterbildung zur systemisch-integrativen Paar- und
                      Familientherapeutin (DGSF)
                    </p>
                    <p className="text-gray-600" data-id="element-885">
                      Münchener Institut für Systemisch-Integrative Therapie
                      (MiSiT e.V.)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg" data-id="element-886">
              <ul className="space-y-5" data-id="element-887">
                <li className="flex items-start" data-id="element-888">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-889"></div>
                  <div data-id="element-890">
                    <p className="text-gray-700 font-medium" data-id="element-891">
                      Weiterbildung am Institut für systemische Beratung,
                      Wiesloch bei Heidelberg (isb)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-892">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-893"></div>
                  <div data-id="element-894">
                    <p className="text-gray-700 font-medium" data-id="element-895">
                      Zertifizierung als Coach durch Korn Ferry
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-896">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-897"></div>
                  <div data-id="element-898">
                    <p className="text-gray-700 font-medium" data-id="element-899">
                      Heilpraktikerin für Psychotherapie
                    </p>
                    <p className="text-gray-600" data-id="element-900">Zulassung in Bayern</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-901">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-902">
            Berufliche Stationen und internationale Erfahrung
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:gap-8" data-id="element-903">
            <div className="bg-gray-50 rounded-lg" data-id="element-904">
              <ul className="space-y-5" data-id="element-905">
                <li className="flex items-start" data-id="element-906">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-907"></div>
                  <div data-id="element-908">
                    <p className="text-gray-600" data-id="element-909">
                      Munich Re: Seit 2001 Konzernerfahrung in unterschiedlichen
                      globalen HR Rollen (u.a. Globales Talent Management sowie
                      strategische Rollen im Business)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-910">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-911"></div>
                  <div data-id="element-912">
                    <p className="text-gray-600" data-id="element-913">
                      Geschäftsführerin beim Verein zur Förderung politischen
                      Handelns (vfh) in Bonn
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-914">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-915"></div>
                  <div data-id="element-916">
                    <p className="text-gray-600" data-id="element-917">
                      Lehrbeauftragte an der Universität Saarbrücken für
                      Sozialpsychologie
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg" data-id="element-918">
              <ul className="space-y-5" data-id="element-919">
                <li className="flex items-start" data-id="element-920">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-921"></div>
                  <div data-id="element-922">
                    <p className="text-gray-600" data-id="element-923">
                      Drogen- und Suchtberatung bei Prop Shop, Freising
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-924">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-925"></div>
                  <div data-id="element-926">
                    <p className="text-gray-600" data-id="element-927">
                      Isar-Amper-Klinikum, Region München
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-928">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-929"></div>
                  <div data-id="element-930">
                    <p className="text-gray-600" data-id="element-931">
                      Klinik für Psychiatrie und Psychotherapie, München
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-932">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-933"></div>
                  <div data-id="element-934">
                    <p className="text-gray-600" data-id="element-935">
                      UNICEF, New York, und Bundesministerium für
                      wirtschaftliche Zusammenarbeit und Entwicklung (BMZ), Bonn
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-936">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-937">
            Publikationen
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:gap-8" data-id="element-938">
            <div className="bg-gray-50 rounded-lg" data-id="element-939">
              <ul className="space-y-5" data-id="element-940">
                <li className="flex items-start" data-id="element-941">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-942"></div>
                  <div data-id="element-943">
                    <p className="text-gray-600" data-id="element-944">
                      Rekrutierungsstrategien für internationale Trainees bei
                      einem globalen Rückversicherer – ein Fallbeispiel,
                      Springer Verlag 2024 in Hrsg. Heinke Steiner. Online
                      Assessment-Grundlagen und Anwendung von Online Tests in
                      der Unternehmenspraxis, 2. Auflage
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-945">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-946"></div>
                  <div data-id="element-947">
                    <p className="text-gray-600" data-id="element-948">
                      Ansatzpunkte für eine Integration von mehr Frauen in
                      Führungspositionen, Deutsche Gesellschaft für
                      Personalführung, März 2012
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg" data-id="element-949">
              <ul className="space-y-5" data-id="element-950">
                <li className="flex items-start" data-id="element-951">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-952"></div>
                  <div data-id="element-953">
                    <p className="text-gray-600" data-id="element-954">
                      Spannungsfeld Berufsdomäne – wirkt sich die Tätigkeit in
                      einer Männer- und Frauendomäne negativ auf das
                      Karriereverhalten von Frauen und Männern aus? Bertuch
                      Verlag, 1. Mai 2005
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-955">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-956"></div>
                  <div data-id="element-957">
                    <p className="text-gray-600" data-id="element-958">
                      Angelika Scholbeck (heute Sturny): Das Karriereverhalten
                      von Frauen und Männern in unterschiedlichen Berufsdomänen
                      – empirische Untersuchung im Ingenieurswesen, Pflege- und
                      Ärztebereich, Röhrig Universitätsverlag, 1. Februar 2001
                      (Dissertation: Wirtschaftspsychologie)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8 mb-24" data-id="element-959">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-960">
            Ehrenamt
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:gap-8" data-id="element-961">
            <div className="bg-gray-50 rounded-lg" data-id="element-962">
              <ul className="space-y-5" data-id="element-963">
                <li className="flex items-start" data-id="element-964">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-965"></div>
                  <div data-id="element-966">
                    <p className="text-gray-600" data-id="element-967">
                      5 Jahre Stadträtin in Heidelberg (1994-1999)
                      (Schwerpunkte: Stadtentwicklung, Soziales, Kinder- und
                      Frauenpolitik), Aufsichtsrat u.a. Volkshochschule
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-968">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-969"></div>
                  <div data-id="element-970">
                    <p className="text-gray-600" data-id="element-971">
                      Seit 1991 Mitglied der Fachberatungsstelle gegen
                      sexualisierte Gewalt des Frauennotrufs Heidelberg; seit
                      2022 Vorstandsmitglied
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg" data-id="element-972">
              <ul className="space-y-5" data-id="element-973">
                <li className="flex items-start" data-id="element-974">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-975"></div>
                  <div data-id="element-976">
                    <p className="text-gray-600" data-id="element-977">
                      2 Jahre Mitglied des Vorstandes TAMAD (Freunde des Tel
                      Aviv Museum, Kinderfriedensprojekt in Tel Aviv)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-978" />
    </div>;
}